/**
 * Offers a file to the browser's download, from text or bytes.
 * @param {string} filename
 * @param {BlobPart} data
 * @param {string} type
 */
export function download(
  filename: string,
  data: BlobPart,
  type: string = "text/markdown;charset=utf-8",
) {
  const url = URL.createObjectURL(new Blob([data], { type }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.style.display = "none";
  document.body.append(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
